import i18n from 'i18next'
import {initReactI18next} from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import resourcesToBackend from 'i18next-resources-to-backend'
const fallbackLng = ['en']

i18n
  .use(initReactI18next)
  .use(
    resourcesToBackend((language, namespace, callback) => {
      import(`./translations/${language}/${namespace}.json`)
        .then(resources => {
          callback(null, resources)
        })
        .catch(error => {
          callback(error, null)
        })
    }),
  )
  .use(LanguageDetector)
  .init({
    fallbackLng,
    debug: false,
  })

export {i18n}
